import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const ASSET_BASE = BACKEND_URL;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const SIZES = ["36" ,"38", "40", "42", "44", "46"];

export const fmt = (n) => Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtInt = (n) => Number(n || 0).toLocaleString("en-IN");

export function formatApiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  return String(d);
}

export function resolveImage(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  // Migrate legacy "/uploads/" → "/api/uploads/" (ingress only routes /api/* to backend)
  if (path.startsWith("/uploads/")) path = "/api" + path;
  return `${ASSET_BASE}${path}`;
}
